/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import logo from '../Recursos/logo_color.svg'
import {CONTACTOS, DIRECCIONLOCALES, NEGRITA, REDES, SECCIONES} from "../Constantes";
import {Circle, LocationOn, Mail, WhatsApp} from '@mui/icons-material'
import {useIrRuta} from "../Utilidades/useIrRuta";
import {useNavigate} from "react-router-dom";
import {scrolearAComponente} from "../Utilidades/scrolearAComponente";
import {iniciarChatWass} from "../Utilidades/iniciarChatWass";
import {irUrl} from "../Utilidades/irUrl";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../Servicios/BD/obtenerColWheres";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politicas";
import {theme} from "../Tema";


const Footer = () => {
    const {sCell} = useResponsive()
    const {ir} = useIrRuta()
    const navigate = useNavigate();
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [politicas, setPoliticas] = useState([]);

    const irLocal = (nom) => {

        navigate('/Locales')
        setTimeout(() => {
            scrolearAComponente(nom)
        }, 500)
    }

    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'politicas', wheres: w}).then((dox) => {
            setPoliticas(dox.data)
        })

    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#000'}}
        >

            <Dialogo/>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 6, color: '#fff'}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 6, mt: 2}}>
                            <img src={logo} width={sCell ? 250 : 300} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 22}}>Links Rápidos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 3}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={1}
                                    >


                                        {SECCIONES.map((it) => (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <Typography
                                                    onClick={() => ir(it)}
                                                    sx={{
                                                        fontSize: 16,
                                                        cursor: 'pointer',
                                                        transition: 'all .2s ease-in-out',
                                                        borderBottom: 1,
                                                        borderColor: '#ffffff00',
                                                        '&:hover': {
                                                            borderColor: '#ffffff',
                                                        }

                                                    }}>{it}</Typography>
                                            </Grid>
                                        ))}

                                        {politicas.map((it) => (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <Typography
                                                    onClick={() => abrir(it)}
                                                    sx={{
                                                        fontSize: 16,
                                                        cursor: 'pointer',
                                                        transition: 'all .2s ease-in-out',
                                                        borderBottom: 1,
                                                        borderColor: '#ffffff00',
                                                        '&:hover': {
                                                            borderColor: '#ffffff',
                                                        }

                                                    }}>{it.titulo}</Typography>
                                            </Grid>
                                        ))}


                                    </Grid>

                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 22}}>Contactos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 800}}>
                                        <span><LocationOn sx={{mt: 0.7, mb: -0.7, pr: 1}}/></span>
                                        Locales Ipiales</Typography>
                                </Grid>

                                {DIRECCIONLOCALES.map((it, index) => {

                                    if (index < 4) {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography
                                                    onClick={() => irLocal(it.nombre)}
                                                    sx={{
                                                        fontSize: 16,
                                                        fontWeight: 400,
                                                        cursor: 'pointer',
                                                        transition: 'all .2s ease-in-out',
                                                        borderBottom: 1,
                                                        borderColor: '#ffffff00',
                                                        "&:hover": {
                                                            borderColor: '#ffffff',
                                                        }
                                                    }}>
                                                <span><Circle
                                                    sx={{mt: -0.1, mb: 0.1, pr: 1, width: 8, height: 8, pl: 4}}/></span>
                                                    {it.direccion}</Typography>
                                            </Grid>
                                        )
                                    }

                                })}

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 800}}>
                                        <span><LocationOn sx={{mt: 0.7, mb: -0.7, pr: 1}}/></span>
                                        Locales Tuquerres</Typography>
                                </Grid>

                                {DIRECCIONLOCALES.map((it, index) => {

                                    if (index >= 4) {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 1}}>
                                                <Typography
                                                    onClick={() => irLocal(it.nombre)}
                                                    sx={{
                                                        fontSize: 16,
                                                        fontWeight: 400,
                                                        cursor: 'pointer',
                                                        transition: 'all .2s ease-in-out',
                                                        borderBottom: 1,
                                                        borderColor: '#ffffff00',
                                                        "&:hover": {
                                                            borderColor: '#ffffff',
                                                        }
                                                    }}>
                                                <span><Circle
                                                    sx={{mt: -0.1, mb: 0.1, pr: 1, width: 8, height: 8, pl: 4}}/></span>
                                                    {it.direccion}</Typography>
                                            </Grid>
                                        )
                                    }

                                })}


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 3}}>
                                    <Typography
                                        onClick={() => iniciarChatWass({})}
                                        sx={{
                                            fontSize: 18,
                                            fontWeight: 800,
                                            cursor: 'pointer',
                                            transition: 'all .2s ease-in-out',
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            "&:hover": {
                                                borderColor: '#ffffff',
                                            }
                                        }}>
                                        <span><WhatsApp sx={{mt: 0.7, mb: -0.7, pr: 1}}/></span>
                                        {CONTACTOS[0].descripcion}</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{fontSize: 18, fontWeight: 800}}>
                                        <span><Mail sx={{mt: 0.7, mb: -0.7, pr: 1}}/></span>
                                        {CONTACTOS[1].descripcion}</Typography>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 22}}>Horarios de
                                        atencion Ipiales</Typography>
                                </Grid>

                                {DIRECCIONLOCALES.map((it, index) => {

                                    if (index < 4)
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 6}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <Grid
                                                    container
                                                    justifyContent={'flex-start'}
                                                    alignItems={'flex-start'}
                                                    size={{xs: 12, sm: 12, md: 12}}>

                                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                          sx={{justifyContent: 'flex-start', mt: 2}}>
                                                        <Typography sx={{
                                                            fontSize: 18,
                                                            fontWeight: 800,
                                                            fontFamily: NEGRITA,
                                                            color: theme.palette.primary.main
                                                        }}>
                                                            {it.nombre.toUpperCase()}</Typography>
                                                    </Grid>


                                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                          sx={{justifyContent: 'flex-start', mt: 0}}>
                                                        <Typography sx={{fontSize: 18, fontWeight: 800}}>
                                                            {it?.dias}</Typography>
                                                    </Grid>


                                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                          sx={{justifyContent: 'flex-start', mt: 0}}>
                                                        <Typography
                                                            sx={{fontSize: it.size ? it.size : 16, fontWeight: 400}}>
                                                            {it?.horas}</Typography>

                                                        {it.horasdos &&

                                                            <>
                                                                <br/>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: it.size ? it.size : 16,
                                                                        fontWeight: 400,
                                                                        mt: 0
                                                                    }}>
                                                                    {it?.horasdos}</Typography>
                                                            </>

                                                        }

                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        )
                                })}


                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 22}}>Horarios de
                                        atencion Tuquerres</Typography>
                                </Grid>

                                {DIRECCIONLOCALES.map((it, index) => {

                                    if (index >= 4)
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 6}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <Grid
                                                    container
                                                    justifyContent={'flex-start'}
                                                    alignItems={'flex-start'}
                                                    size={{xs: 12, sm: 12, md: 12}}>

                                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                          sx={{justifyContent: 'flex-start', mt: 2}}>
                                                        <Typography sx={{
                                                            fontSize: 18,
                                                            fontWeight: 800,
                                                            fontFamily: NEGRITA,
                                                            color: theme.palette.primary.main
                                                        }}>
                                                            {it.nombre.toUpperCase()}</Typography>
                                                    </Grid>


                                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                          sx={{justifyContent: 'flex-start', mt: 0}}>
                                                        <Typography sx={{fontSize: 18, fontWeight: 800}}>
                                                            {it?.dias}</Typography>
                                                    </Grid>


                                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                          sx={{justifyContent: 'flex-start', mt: 0}}>
                                                        <Typography
                                                            sx={{fontSize: it.size ? it.size : 16, fontWeight: 400}}>
                                                            {it?.horas}</Typography>

                                                        {it.horasdos &&

                                                            <>
                                                                <br/>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: it.size ? it.size : 16,
                                                                        fontWeight: 400,
                                                                        mt: 0
                                                                    }}>
                                                                    {it?.horasdos}</Typography>
                                                            </>

                                                        }

                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        )
                                })}


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 800}}>
                                        Síguenos en nuestras redes</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        {REDES.map((it) => (
                                            <Grid container size={{xs: 2, sm: 3, md: 2}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <IconButton
                                                    onClick={() => irUrl(it.url)}
                                                >
                                                    <img src={it.imgColor} width={40}/>
                                                </IconButton>
                                            </Grid>
                                        ))}

                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}}
                      sx={{justifyContent: 'center', borderTop: 1, mt: 8, pt: 3, borderColor: '#ffffff50'}}>
                    <Typography sx={{color: '#fff'}}>© QUESUDITAS 2026 - 2027</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer